import { defineStore } from "pinia";

export interface ChatMsg {
  id: string;
  prompt: string;
  isLoading: boolean;
  aiResponse: string;
}

export const useChatMessagesStore = defineStore("chatMessages", {
  state: () => ({
    messages: {} as Record<string, ChatMsg[]>,
  }),
  actions: {
    add(namespace: string, msg: ChatMsg) {
      if (!this.messages[namespace]) this.messages[namespace] = [];
      this.messages[namespace].push(msg);
    },
    update(namespace: string, id: string, patch: Partial<ChatMsg>) {
      const list = this.messages[namespace];
      if (!list) return;
      const msg = list.find((m) => m.id === id);
      if (msg) Object.assign(msg, patch);
    },
    clear(namespace: string) {
      this.messages[namespace] = [];
    },
  },
});
